import {Box, Typography} from "@mui/material";
import {c, maxW} from "../landingTokens";

const METRICS = [
  {value: "70", unit: "%", label: "of FAQs resolved with no human help"},
  {value: "<1", unit: "s", label: "to greet a caller — no hold time"},
  {value: "100", unit: "+", label: "customer intents understood out of the box"},
  {value: "24", unit: "/7", label: "multilingual coverage, zero downtime"},
];

export const Metrics = () => (
  <Box component="section" data-screen-label="Metrics" sx={{px: 2.75, py: {xs: 3, md: 5}, bgcolor: c.bg}}>
    <Box
      sx={{
        maxWidth: maxW,
        mx: "auto",
        px: {xs: 2.5, md: 4.25},
        py: {xs: 4.5, md: 5.75},
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))",
        gap: {xs: 4, md: 2},
        border: `1px solid ${c.line}`,
        borderRadius: "28px",
        bgcolor: c.bgSoft,
        boxShadow: "0 22px 60px -48px rgba(55, 56, 113, 0.65)",
      }}
    >
        {METRICS.map((m, index) => (
            <Box
                key={m.label}
                sx={{
                    pl: {xs: 0, md: index === 0 ? 0 : 3},
                    borderLeft: {xs: "none", md: index === 0 ? "none" : `1px solid ${c.line}`},
                    pt: {xs: index === 0 ? 0 : 3, md: 0},
                    borderTop: {xs: index === 0 ? "none" : `1px solid ${c.line}`, md: "none"},
                }}
            >
                <Typography
                    sx={{
                        fontSize: "clamp(44px, 12vw, 68px)",
                        fontWeight: 700,
                        letterSpacing: "-0.06em",
                        lineHeight: 0.95,
                        color: c.ink,
                        textAlign: {xs: "center", md: "left"},
                    }}
                >
                    {m.value}
                    <Box component="span" sx={{color: c.purpleDeep, fontSize: "0.62em", ml: 0.35}}>{m.unit}</Box>
                </Typography>

                <Typography
                    sx={{
                        fontSize: 14,
                        color: c.inkSoft,
                        mt: 1.75,
                        lineHeight: 1.45,
                        maxWidth: 200,
                        mx: {xs: "auto", md: 0},
                        textAlign: {xs: "center", md: "left"},
                    }}
                >
                    {m.label}
                </Typography>
            </Box>
        ))}
    </Box>
  </Box>
);
